import { render, staticRenderFns } from "./NewAiComponent.vue?vue&type=template&id=6ab2e1aa&scoped=true"
import script from "./NewAiComponent.vue?vue&type=script&lang=js"
export * from "./NewAiComponent.vue?vue&type=script&lang=js"
import style0 from "./NewAiComponent.vue?vue&type=style&index=0&id=6ab2e1aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab2e1aa",
  null
  
)

export default component.exports